import { Controller } from "@hotwired/stimulus";
import i18n from "../lib/i18n";

export default class extends Controller {
  static targets = ["form"];

  connect() {
    this.initialFormState = new URLSearchParams(
      new FormData(this.formTarget)
    ).toString();
    // set initial form state as data attribute so that we can access it from
    // e.g. close_pop_out_controller.js
    this.formTarget.setAttribute(
      "data-initial-form-state",
      this.initialFormState
    );

    this.element.addEventListener(
      "puts-pop-out:before-close",
      this.handleTurboConfirmOnClose
    );
  }

  disconnect() {
    this.element.removeEventListener(
      "puts-pop-out:before-close",
      this.handleTurboConfirmOnClose
    );
  }

  handleTurboConfirmOnClose = (event) => {
    if (!this.confirmClose()) {
      event.preventDefault();
      return;
    }
  };

  confirmClose() {
    const currentFormState = new URLSearchParams(
      new FormData(this.formTarget)
    ).toString();

    if (this.initialFormState !== currentFormState) {
      const confirmMessage = i18n.t(
        "js.stimulus_controllers.turbo_confirm.confirm_close"
      );
      return confirm(confirmMessage);
    }
    return true;
  }
}
